// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__fOOlv","title":"AfterImages90_title__1UVHP","images":"AfterImages90_images__SJXY4"};